module.exports = OrderStatesFinal = 
{
    PENDING         : 100,
    QUEUED          : 200,
    IN_PRODUCTION   : 300,
    FINISHED        : 400    
}